<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="!$route.query.customerId" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.customerId == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <!-- Customer group dropdown -->
            <!--
            <CustomerSelect v-model="parentcustomerfilter"
              :label="$t('servicesystem.common_objects.customer.parent_org')" clearable externaledit multiple
              class="my-3 mx-3">
            </CustomerSelect>
            -->
            <v-container v-if="publicModeEnabled">
              <v-row no-gutters justify="start" align="center" class="pb-3">
                <p class="mr-3 mb-0">{{ $t("servicesystem.common_objects.commonterms.public") }}:</p>
                <QButtonGroup v-model="publicfilter" :list="publicFilterOptions" :edit="true" dense noempty>
                </QButtonGroup>
              </v-row>
            </v-container>
            <v-container>
              <v-row no-gutters justify="start" align="center" class="pb-3">
                <p class="mr-3 mb-0">{{ $t("servicesystem.common_objects.customer.has_active_machines") }}:</p>
                <QButtonGroup v-model="hasActiveMachinesFilter" :list="activeMachinesOptions" :edit="true" dense
                  noempty>
                </QButtonGroup>
              </v-row>
            </v-container>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>

          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getCustomerListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="40" ref="ListPane"
          :set-preview-function="openPreview" :openFunction="openItem" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" :preselected="($route.query.customerId == item.Id)" previewable
              @click="openItem(item)" @openPreview="openPreview(item)" @closePreview="closePreview()">
            </ListItem>
          </template>

        </ListPane>
      </template>

      <template v-slot:preview>
        <PreviewPane :id="$route.query.customerId" :showToolbar="true" />
      </template>

    </Layout>

    <NewCustomerDialog :externaltrigger="dialogtrigger" @Update="handleadded" @Created="handleDialogCreate">
    </NewCustomerDialog>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import NewCustomerDialog from "@/components/Dialogs/NewCustomerDialog.vue";
import ListItem from "@/components/ListItems/CustomerListItem.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import PreviewPane from "@/views/job/newjob/cards/customer/PreviewCustomer.vue";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
  name: "AdminCustomerList",
  props: {},
  components: {
    FilterPane,
    ListPane,
    PreviewPane,
    Layout,
    ListItem,
    NewCustomerDialog,
    DefaultLifeCycleFilterGroup,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "CL-",
      publicFilterOptions: [
        { value: 0, text: this.$t("servicesystem.common_objects.commonterms.any") },
        { value: 1, text: this.$t("servicesystem.common_objects.commonterms.yes") },
        { value: -1, text: this.$t("servicesystem.common_objects.commonterms.no") },
      ],
      activeMachinesOptions: [
        { value: 0, text: this.$t("servicesystem.common_objects.commonterms.any") },
        { value: 1, text: this.$t("servicesystem.common_objects.commonterms.yes") },
        { value: -1, text: this.$t("servicesystem.common_objects.commonterms.no") },
      ]
    };
  },

  created() {
    this.$store.dispatch("JobHub/JobPreview/setPreviewCustomer", null);
  },

  mounted() { },

  methods: {
    openPreview(item) {
      var query = Object.assign({}, this.$route.query);
      query.customerId = item.Id;
      this.$router.replace({ query });
      this.$store.dispatch("JobHub/JobPreview/getPreviewCustomer", item.Id);
    },
    closePreview() {
      var query = Object.assign({}, this.$route.query);
      query.customerId = undefined;
      this.$router.replace({ query });
      this.$store.dispatch("JobHub/JobPreview/setPreviewCustomer", null);
    },
    openItem(item) {
      var query = (this.$route.name == "CustomerList") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewCustomer', params: { customerId: item.Id }, query })
    },

    handleDialogCreate(e) {
      this.handleadded(e);
      this.openItem(e);
    },

    handleadded(item) { this.$refs.ListPane.handleadded(item) },
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),
  },

  computed: {
    dialogtrigger() { return this.$store.state.triggerevents.newDialogTrigger; },

    PreviewCustomer() { return this.$store.getters["JobHub/JobPreview/PreviewCustomer"]; },

    publicModeEnabled() { return this.$store.state.GlobalSettings.Features.PublicPortalEnabled; },

    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes("filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          HasActiveMachines: this.hasActiveMachinesFilter,
          PublicState: this.publicfilter,
          ParentCustomerIdList: this.parentcustomerfilter,
          CustomerGroupIdList: this.customergroupfilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    parentcustomerfilter: {
      get() { return this.getQueryParam("filter-parentcustomer", []); },
      set(update) { this.setQueryParam("filter-parentcustomer", update); },
    },

    customergroupfilter: {
      get() { return this.getQueryParam("filter-customergroup", []); },
      set(update) { this.setQueryParam("filter-customergroup", update); },
    },

    publicfilter: {
      get() { return this.getQueryParam("filter-public", 0); },
      set(update) { this.setQueryParam("filter-public", update); },
    },

    hasActiveMachinesFilter: {
      get() { return this.getQueryParam("filter-activemachines", 0); },
      set(update) { this.setQueryParam("filter-activemachines", update); }
    }

  },

  watch: {},
};
</script>